import React, { memo } from 'react';
import { Box, InputLabel, TextField } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

/**
 * Multiline Text Field Component
 * 複数行のテキストボックス
 * @author hiroto.nishisuji
 *
 * @param props
 * @returns {*}
 * @constructor
 */

/* ************ Style ************ */
const useStyles = makeStyles()(() => ({
  root: {
    '& .outlinedLabel': {
      color: '#0D0D0D',
      margin: '0 8px 0 0',
      fontSize: '23px',
    },
    '& .outlinedInput': {
      background: '#FFFFFF',
      margin: '4px 0 0 0',
      '& textarea': {
        padding: '0 8px',
        fontSize: '23px',
      },
    },
    '& .Mui-disabled': {
      background: '#EBEBEB',
      color: '#0D0D0D',
    },
  },
}));

/* ************ Type ************ */
type Props = {
  id: string;
  name?: string;
  label?: string;
  value?: string;
  placeholder?: string;
  type?: 'text' | 'password'; // number date
  disabled?: boolean;
  fullWidth?: boolean;
  labelPlacement?: 'start' | 'top';
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

/* ************ Function ************ */
const setLabelPlacement = (labelPlacement: string) => {
  if (labelPlacement === 'start') {
    return 'row';
  }
  return 'column';
};

/* ************ Component ************ */
const TextArea: React.FC<React.PropsWithChildren<Props>> = memo((props) => {
  const { classes } = useStyles();
  const {
    id,
    name,
    value,
    placeholder,
    label,
    onChange,
    disabled = false,
    fullWidth = false,
    labelPlacement = 'start',
    type = 'text',
    className = '',
  } = props;

  return (
    <Box
      className={`${classes.root} ${className}`}
      sx={{
        display: "flex",
        flexDirection: setLabelPlacement(labelPlacement),
        alignItems: "baseline",
      }}>
      {label && (
        <InputLabel htmlFor={id} className="outlinedLabel">
          {label}
        </InputLabel>
      )}
      <TextField
        id={id}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        type={type}
        onChange={onChange}
        className="outlinedInput"
        fullWidth={fullWidth}
        multiline
        rows={4}
        variant="standard"
      />
    </Box>
  );
});

export default TextArea;
